<div class="storage-page-preview-container">
    <!-- Loading state -->
     
    <div *ngIf="isLoading" class="preview-loading">
        <div class="loader">
            <div class="dimmed">
                <div class="dimmed_box"></div>
            </div>
        </div>
        
    </div>

    <!-- Error state -->
    <div *ngIf="errorMessage && !isLoading" class="preview-error">
        <core-helpers-box-alert-message-icon
            [text]="'No preview available'"
            [icon]="'alert'">
        </core-helpers-box-alert-message-icon>
    </div>

    <!-- Image display -->
    <img 
        #img 
        *ngIf="!errorMessage"
        [hidden]="isLoading" 
        class="preview-image"
        [src]="presignedUrl"
        [attr.alt]="alt"
        (load)="onLoadImg()"
        (error)="onLoadImgError($event)">
</div>
